import { useRef } from 'react'
import { useTilt } from './motion'
import { Status, type Tone } from './Status'

// One integration in the catalogue: its mark, its name, one line on what it
// does, one status and one action.
//
// # WHY THE WHOLE CARD IS THE BUTTON
//
// Everything about an integration beyond that line (what it does step by
// step, the field mapping, setup, the connection test and the last deliveries)
// lives in the drawer the card opens. A card with its own row of buttons
// becomes a small settings page repeated thirty times, which is the clutter the
// redesign removes. The action word says what opening it is for: Connect, Fix,
// Manage, View plan.
//
// `markColor` sits behind white letters, so it has to be dark enough to carry
// them; the catalogue picks it.

export function IntegrationCard({
  mark,
  markColor,
  name,
  line,
  status,
  statusTone,
  action,
  onOpen,
  featured,
}: {
  mark: string
  markColor: string
  name: string
  line: string
  status: string
  statusTone: Tone
  action: string
  onOpen: () => void
  featured?: boolean
}) {
  const card = useRef<HTMLButtonElement>(null)
  useTilt(card, { max: 5 })
  return (
    <button ref={card} type="button" className={'kit-icard' + (featured ? ' kit-featured' : '')} onClick={onOpen}>
      <span className="kit-icard-top">
        <span className="kit-icard-mark" style={{ background: markColor }} aria-hidden="true">
          {mark}
        </span>
        <span className="kit-icard-name">{name}</span>
      </span>
      <span className="kit-icard-line">{line}</span>
      <span className="kit-icard-foot">
        <Status tone={statusTone}>{status}</Status>
        <span className="kit-icard-action">{action}</span>
      </span>
    </button>
  )
}
